import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.map.js";
import React, { useMemo, useCallback } from 'react';
import { Card, Typography } from '@applyboard/ui-components';
import { useEventTracker } from '@applyboard/ui-utils';
import { IntakeEntry } from "./IntakeEntry";
export function Intakes(_ref) {
  var intakes = _ref.intakes,
    showCloseConditonToUser = _ref.showCloseConditonToUser;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var trackCollapseEvent = useCallback(function (startDate) {
    return trackEvent({
      event: 'Programs Page - Clicked Drop-Down',
      data: {
        type: 'intake',
        startDate: startDate
      }
    });
  }, [trackEvent]);
  var sortedIntakes = useMemo(function () {
    return intakes === null || intakes === void 0 ? void 0 : intakes.sort(function (intakeA, intakeB) {
      return intakeA.startDate.localeCompare(intakeB.startDate);
    });
  }, [!!intakes]);
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "Program Intakes"), intakes !== null && intakes !== void 0 && intakes.length ? sortedIntakes === null || sortedIntakes === void 0 ? void 0 : sortedIntakes.map(function (intake) {
    return /*#__PURE__*/React.createElement(IntakeEntry, {
      key: intake.id,
      intake: intake,
      showCloseConditonToUser: showCloseConditonToUser,
      onToggleCollapsed: trackCollapseEvent
    });
  }) : /*#__PURE__*/React.createElement(Typography, {
    mt: 2
  }, "No intake dates available at the moment"));
}